/**
 * @file Contains the hook for getting the settings navigation parameters
 */
import useIsComposeOpen from '../../../../../hooks/router/search/useIsComposeOpen';
import useIsMobile from '../../../../../hooks/useIsMobile';
import { getIsTemplatesPage } from '../../../../../routes/helpers/pages';
import { getCanCreateTemplate } from '../../../../../utils/permissions/template';

/**
 * Hook for getting the settings navigation parameters
 *
 * @returns Parameters for showing the compose and floating button
 */
const useSettingsNavigation = () => {
  const isComposeOpen = useIsComposeOpen();
  const isMobile = useIsMobile();

  const shouldShowCompose =
    getIsTemplatesPage() && getCanCreateTemplate() && isMobile === false;
  const shouldShowFloatingButton =
    !isComposeOpen && (getIsTemplatesPage() || isMobile === true);

  return {
    shouldShowCompose,
    shouldShowFloatingButton,
  };
};

export default useSettingsNavigation;
